import React, {useEffect} from 'react';
import Wrapper from '../../components/Wrapper';
import DashboardHeader from '../../components/DashboardHeader';
import {
  useGetAssignedQuery,
  useLazyGetAssignedQuery,
} from '../../store/builder/inspections.api';
import './index.scss';
import {useDispatch} from 'react-redux';
import {setLoader} from '../../store/builder/reducer';
import Select from 'react-select';
import {useGetRevisions} from '../EquipmentType/model/revisions/getRevisions';
import {useSetCurrentRevision} from '../EquipmentType/model/revisions/setCurrentRevision';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useTranslation} from '../../hooks/useTranslation';

const SELECT_STYLED = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
    borderRadius: 8,
    height: 45,
    backgroundColor: '#F4F5F6',
    marginTop: 8,
  }),
};

export default function AssignedInspections() {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [getAssigned, {data, isError, isLoading, isSuccess, error}] =
    useLazyGetAssignedQuery();

  const [getRevisions, revisionOptions, current_revision] = useGetRevisions();
  const [handleSelect] = useSetCurrentRevision();

  useEffect(() => {
    if (!current_revision) {
      getRevisions(searchParams.get('revision'));
    }
  }, []);

  useEffect(() => {
    dispatch(setLoader(true));
    getAssigned({revision: current_revision?.code})
      .unwrap()
      .then(res => {
        dispatch(setLoader(false));
      })
      .catch(err => {
        dispatch(setLoader(false));
      });
  }, [current_revision]);

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
  }, [isLoading, isSuccess]);
  return (
    <Wrapper>
      <DashboardHeader
        title={t('assignedInspections.title')}
        type={'assigned'}
        cancelNav={'/equipment-type'}
      />
      <div className='assigned'>
        <div className='assigned__select'>
          <Select
            options={revisionOptions.filter(el => el.code !== '')}
            styles={SELECT_STYLED}
            value={revisionOptions.filter(el => el.code === current_revision?.code)[0]}
            onChange={async selected => {
              await handleSelect(selected);
              await navigate(
                '/equipment-type/assigned' + `?revision=${selected?.code}`,
              );
            }}
          />
        </div>
        {data?.form_groups?.map(category => (
          <div className='assigned__category' key={category?.key}>
            <p className='assigned__category-name'>{category?.name}</p>
            <div className='assigned__forms'>
              {category?.forms?.map((form, index) => (
                <div key={form?.id} className='assigned__form'>
                  <p className='assigned__form-name'>{form.name}</p>
                  <div
                    className='assigned__form-box'
                    style={
                      index === category?.forms.length - 1
                        ? {borderBottom: 'none'}
                        : null
                    }
                  >
                    {form?.links.length > 0
                      ? form?.links?.map(link => (
                          <div className='assigned__link' key={link.id}>
                            <p className='assigned__link-name'>{link?.name}</p>
                          </div>
                        ))
                      : t('assignedInspections.noData')}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Wrapper>
  );
}
